import { useEffect } from "react";
import type { AppLanguage } from "./language";

const exactTranslations: Record<string, string> = {
  "Preparing workspace": "ワークスペースを準備しています",
  "Checking access…": "アクセスを確認しています…",
  "Ticket update failed": "チケットの更新に失敗しました",
  "Dismiss": "閉じる",

  "Dashboard": "ダッシュボード",
  "Calendar": "カレンダー",
  "Tickets": "チケット",
  "Customers": "顧客",
  "Items": "項目",
  "Knowledge Base": "ナレッジ",
  "Reporting": "レポート",
  "Logs": "ログ",
  "Archive": "アーカイブ",
  "Users": "ユーザー",
  "Settings": "設定",

  "In Progress": "対応中",
  "Pending": "保留中",
  "Resolved": "解決済み",
  "Open": "未対応",
  "Assigned to you": "あなたに割り当て",
  "Your Active Tickets": "担当中のチケット",
  "Updated today": "本日更新",
  "Resolved Today": "本日解決",
  "Opened today": "本日作成",
  "Tickets Created": "作成されたチケット",
  "Active now": "現在対応中",
  "Up next": "次の予定",
  "No notes added for this assignment.": "この割り当てにはまだメモがありません。",

  "Task rotation": "タスクローテーション",
  "the current week": "今週",
  "the current month": "今月",
  "Members covered": "対応メンバー数",
  "Active members with at least one visible assignment.": "表示中の割り当てを少なくとも 1 件持つアクティブメンバー数です。",
  "On-call coverage": "オンコール対応率",
  "Days with explicit on-call coverage this week.": "今週オンコール担当が明示されている日数です。",
  "Days in the month with explicit on-call coverage.": "今月オンコール担当が明示されている日数です。",
  "Rotations active": "稼働中のローテーション",
  "This week": "今週",
  "This month": "今月",
  "Close schedule assignment": "スケジュール割り当てを閉じる",
  "Update assignment": "割り当てを更新",
  "Create assignment": "割り当てを作成",
  "Primary on-call": "一次オンコール",
  "Add escalation notes, customer focus, or rotation context.": "エスカレーションメモ、対応顧客、またはローテーションの背景を追加します。",
  "Saving…": "保存中…",
  "Save changes": "変更を保存",
  "Close assignment type dialog": "割り当て種別ダイアログを閉じる",
  "Customer success review": "カスタマーサクセスレビュー",
  "Add type": "種別を追加",

  "Managed accounts": "管理中アカウント",
  "Active customer accounts": "アクティブな顧客アカウント",
  "Open tickets": "未解決チケット",
  "Across all customer accounts": "すべての顧客アカウントにまたがる件数",
  "At risk": "要注意",
  "Watch or escalated accounts": "注意またはエスカレーション対象のアカウント",
  "Renewing soon": "更新間近",
  "Products due within 90 days": "90 日以内に更新予定の製品",
  "No primary contact": "主要連絡先なし",
  "Close create customer dialog": "顧客作成ダイアログを閉じる",
  "Create customer": "顧客を作成",

  "Account status": "アカウント状態",
  "Change customer health": "顧客ヘルスを変更",
  "Close dialog": "ダイアログを閉じる",
  "Updated customer status": "顧客ステータスを更新しました",
  "Updated contact": "連絡先を更新しました",
  "Added contact": "連絡先を追加しました",
  "was updated": "を更新しました",
  "was added": "を追加しました",
  "Deleted contact": "連絡先を削除しました",
  "Updated product": "製品を更新しました",
  "Added product": "製品を追加しました",
  "Deleted product": "製品を削除しました",
  "Edit customer profile": "顧客プロフィールを編集",
  "Location not set": "所在地未設定",
  "Create, edit, and remove customer contacts.": "顧客連絡先を作成、編集、削除します。",
  "Read-only customer contacts for this account.": "このアカウントの顧客連絡先は閲覧専用です。",
  "No contacts yet": "連絡先はまだありません",
  "Add a contact to keep account ownership current.": "アカウント担当を最新に保つために連絡先を追加してください。",
  "No phone": "電話番号なし",
  "No items available": "利用可能な項目はありません",
  "Create an item in the Items view before assigning products to this account.": "このアカウントに製品を割り当てる前に、項目ビューで項目を作成してください。",
  "No products yet": "製品はまだありません",
  "Add a product to track renewal timing and footprint.": "更新時期と利用状況を追跡するため製品を追加してください。",
  "No notes yet": "メモはまだありません",
  "Add internal context for the next teammate review.": "次の担当者向けの社内コンテキストを追加してください。",
  "Needs owner": "担当者が必要です",
  "No history yet": "履歴はまだありません",
  "New contact, product, and status changes will appear here.": "新しい連絡先、製品、ステータス変更がここに表示されます。",
  "Edit customer": "顧客を編集",
  "Update the account name and location from the customer profile.": "顧客プロフィールからアカウント名と所在地を更新します。",
  "Edit contact": "連絡先を編集",
  "Create contact": "連絡先を作成",
  "Customer contact": "顧客連絡先",
  "New contact": "新しい連絡先",
  "Create or update the people who own this account and keep outreach details current.": "このアカウントの担当者情報と連絡先詳細を作成または更新します。",
  "Contact name": "連絡先名",
  "Optional phone number": "任意の電話番号",
  "Save contact": "連絡先を保存",
  "Edit product": "製品を編集",
  "Create product": "製品を作成",
  "Update customer product": "顧客製品を更新",
  "Add product": "製品を追加",
  "Assign an item to this account, set the seat count, and track renewal timing in one focused form.": "このアカウントに項目を割り当て、シート数を設定し、更新時期を 1 つのフォームで管理します。",
  "Renewal date": "更新日",
  "Save product": "製品を保存",
  "Edit note": "メモを編集",
  "Create note": "メモを作成",
  "Update account note": "アカウントメモを更新",

  "Ticket ID": "チケット ID",
  "Last Update": "最終更新",
  "Any owner": "担当者を問わない",
  "Include all assignment states.": "すべての割り当て状態を含みます。",
  "Assigned to me": "自分に割り当て",
  "Focus on your queue.": "自分のキューに絞り込みます。",
  "Only tickets with an owner.": "担当者がいるチケットのみ。",
  "Find tickets that need triage.": "トリアージが必要なチケットを探します。",
  "Any schedule": "予定を問わない",
  "Show scheduled and unscheduled work.": "予定あり・なしの両方を表示します。",
  "Tickets with any follow-up time set.": "フォローアップ時刻が設定されているチケット。",
  "Scheduled for now or later.": "現在以降に予定されているもの。",
  "Scheduled time has already passed.": "予定時刻をすでに過ぎたもの。",
  "No follow-up time has been set.": "フォローアップ時刻が設定されていません。",
  "Any time": "期間を問わない",
  "No last-updated restriction.": "最終更新日の制限なし。",
  "Last 24 hours": "過去 24 時間",
  "Recently active tickets.": "最近動きのあったチケット。",
  "Last 7 days": "過去 7 日間",
  "Current weekly queue.": "現在の週間キュー。",
  "Last 30 days": "過去 30 日間",
  "Broad monthly review.": "月次レビュー向け。",
  "Search assignees": "担当者を検索",
  "No filters selected": "フィルター未選択",
  "Always shown": "常に表示",
  "Visible in the table": "テーブルに表示",
  "Hidden from the table": "テーブルに非表示",
  "Current user": "現在のユーザー",
  "Support teammate": "サポート担当者",
  "Close quick view": "クイックビューを閉じる",
  "Change ticket category": "チケットカテゴリを変更",
  "Change ticket priority": "チケット優先度を変更",
  "Change ticket status": "チケットステータスを変更",
  "No schedule set": "予定なし",

  "Existing case note": "既存のケースノート",
  "Pauses SLA": "SLA を一時停止",
  "Customer note · SLA paused": "顧客向けノート · SLA 一時停止中",
  "Unable to load text preview.": "テキストプレビューを読み込めません。",
  "Unable to load PDF preview.": "PDF プレビューを読み込めません。",
  "Untitled ticket": "無題のチケット",
  "Delete ticket": "チケットを削除",
  "Save description": "説明を保存",
  "Add a clear summary of the customer issue and desired outcome.": "顧客の課題と望ましい結果を明確に記述してください。",
  "Search knowledge articles by title, summary, or keyword.": "タイトル、概要、キーワードでナレッジ記事を検索します。",
  "No summary added yet.": "概要はまだありません。",
  "Open article": "記事を開く",
  "Remove article": "記事を削除",
  "Upload attachments": "添付ファイルをアップロード",
  "No linked articles yet.": "関連付けられた記事はまだありません。",
  "No attachments yet.": "添付ファイルはまだありません。",
  "Add internal notes, customer replies, and status updates.": "社内メモ、顧客返信、ステータス更新を追加します。",

  "Add a name and description before creating the collection.": "コレクションを作成する前に名前と説明を入力してください。",
  "Failed to create collection.": "コレクションの作成に失敗しました。",
  "Close collection dialog": "コレクションダイアログを閉じる",
  "Creating…": "作成中…",
  "Create collection": "コレクションを作成",
  "Confirm that all articles in this collection will be deleted.": "このコレクション内のすべての記事が削除されます。よろしいですか。",
  "Failed to delete collection.": "コレクションの削除に失敗しました。",
  "Close delete collection dialog": "コレクション削除ダイアログを閉じる",
  "Deleting…": "削除中…",
  "Delete collection": "コレクションを削除",
  "← Back": "← 戻る",
  "Private": "限定公開",
  "Private section": "限定公開セクション",
  "Edit article": "記事を編集",
  "Created": "作成日",
  "No structured content yet.": "構造化コンテンツはまだありません。",
  "Article metadata": "記事メタデータ",
  "Collection": "コレクション",
  "Visibility": "公開範囲",
  "Featured": "注目記事",
  "Audience": "対象カテゴリ",
  "Author": "作成者",
  "New article": "新しい記事",
  "Create article": "記事を作成",
  "Update published guidance, metadata, and structured content in a focused editing workspace.": "公開済みガイダンス、メタデータ、構造化コンテンツを編集ワークスペースで更新します。",
  "Draft a support article with structured content blocks, internal notes, and publishing metadata in one full-screen workspace.": "構造化コンテンツ、内部メモ、公開メタデータを含むサポート記事を 1 つの全画面ワークスペースで作成します。",
  "Publishing…": "公開中…",
  "Publish article": "記事を公開",
  "Enter article title": "記事タイトルを入力",
  "Short overview for search results and internal previews": "検索結果と内部プレビュー向けの短い概要",
  "Shared workspace": "共有ワークスペース",
  "Visible to everyone who can access the shared knowledge base. Appears in collections and featured sections.": "共有ナレッジにアクセスできる全員に表示され、コレクションや注目記事にも表示されます。",
  "Visible only to you and the teammates you choose. Hidden from shared collections and rankings.": "自分と選択したチームメイトにのみ表示され、共有コレクションやランキングには表示されません。",
  "Loading editor…": "エディターを読み込み中…",
  "Pinned to featured articles": "注目記事に固定",
  "Not pinned": "固定なし",
  "Private articles stay out of featured placement.": "限定公開記事は注目記事には表示されません。",
  "This article will appear in the featured articles section.": "この記事は注目記事セクションに表示されます。",
  "Turn this on to show the article in featured articles.": "オンにすると注目記事に表示されます。",
  "Title and slug are defined": "タイトルとスラッグが設定済みです",

  "Unable to load logs.": "ログを読み込めません。",
  "Unable to load access logs.": "アクセスログを読み込めません。",
  "Unable to load audit logs.": "監査ログを読み込めません。",
  "Choose both a start date and an end date.": "開始日と終了日の両方を選択してください。",
  "The start date must be before the end date.": "開始日は終了日より前である必要があります。",
  "Unable to export the access log range.": "アクセスログ範囲をエクスポートできません。",
  "Unable to export the audit log range.": "監査ログ範囲をエクスポートできません。",
  "Audit capture": "監査記録",
  "Workspace changes are being written to the audit log.": "ワークスペース変更は監査ログに記録されています。",
  "No new audit entries will be captured until audit logging is re-enabled.": "監査ログを再有効化するまで、新しい監査記録は保存されません。",
  "Access capture": "アクセス記録",
  "Session, login, logout, and denied API access attempts are being captured.": "セッション、ログイン、ログアウト、拒否された API アクセス試行が記録されています。",
  "No new access entries will be captured until access logging is re-enabled.": "アクセスログを再有効化するまで、新しいアクセス記録は保存されません。",
  "Recent audit events": "最近の監査イベント",
  "Retention policy: never auto-delete.": "保持ポリシー: 自動削除なし。",
  "Recent access events": "最近のアクセスイベント",
  "Audit trail": "監査履歴",
  "Recent workspace changes": "最近のワークスペース変更",
  "Review the latest workspace changes captured in the workspace audit log.": "ワークスペース監査ログに記録された最新のワークスペース変更を確認します。",
  "Logging disabled. Currently showing up to 10 of the last available logs.": "ログ記録は無効です。現在は取得可能な最新 10 件までを表示しています。",
  "Loading…": "読み込み中…",
  "Access stream": "アクセスストリーム",
  "Recent workspace access events": "最近のワークスペースアクセスイベント",
  "Review recent login, session, logout, and denied API access activity captured for this workspace.": "このワークスペースで記録された最近のログイン、セッション、ログアウト、拒否された API アクセスを確認します。",
  "Audit log export": "監査ログをエクスポート",
  "Export workspace audit logs": "ワークスペース監査ログをエクスポート",
  "Choose the date range for recorded workspace changes, then download the export.": "記録されたワークスペース変更の日付範囲を選択してエクスポートします。",
  "Start date": "開始日",
  "End date": "終了日",
  "Exporting…": "エクスポート中…",
  "Export logs": "ログをエクスポート",
  "Access log export": "アクセスログをエクスポート",
  "Export workspace access logs": "ワークスペースアクセスログをエクスポート",
  "Choose the date range for user and device access attempts, then download the export.": "ユーザーおよびデバイスのアクセス試行の日付範囲を選択してエクスポートします。",

  "Item templates synced 6 mins ago": "項目テンプレートは 6 分前に同期されました",
  "Add a name before saving.": "保存する前に名前を入力してください。",
  "Add at least one price before saving this item.": "この項目を保存する前に少なくとも 1 件の価格を追加してください。",
  "Add a positive SLA value before enabling it for this item.": "この項目で有効にする前に正の SLA 値を設定してください。",
  "Add a valid SLA value before saving this item.": "この項目を保存する前に有効な SLA 値を設定してください。",
  "New item template created just now": "新しい項目テンプレートを作成しました",
  "Tracked items": "管理中の項目",
  "Products, services, and subscriptions available to assign.": "割り当て可能な製品、サービス、サブスクリプションです。",
  "Public items": "公開中の項目",
  "Visible templates currently ready for active customer use.": "現在、顧客利用向けに公開されているテンプレートです。",
  "Saved prices": "保存済み価格",
  "Items with a standard internal price and billing cadence.": "標準内部価格と請求サイクルが設定された項目です。",
  "SLA coverage": "SLA 対応",
  "Tracked items and pricing": "項目と価格の管理",
  "Maintain the internal library your team uses to organize which products, services, and subscriptions each customer account has enabled for their own end customers.": "各顧客アカウントで有効化されている製品、サービス、サブスクリプションを整理するための社内カタログを管理します。",
  "Close catalog modal": "カタログモーダルを閉じる",
  "Create item template": "項目テンプレートを作成",
  "Edit item template": "項目テンプレートを編集",
  "New item": "新しい項目",
  "Item template": "項目テンプレート",
  "No price set": "価格未設定",
  "Clear form": "フォームをクリア",
  "Reset changes": "変更をリセット",
  "Create item": "項目を作成",
  "Save item": "項目を保存",

  "No workspace expiry": "ワークスペース期限なし",
  "Never auto-delete": "自動削除しない",
  "Sync failed": "同期に失敗しました",
  "Open this workspace on its workspace domain before saving mailboxes.": "メールボックスを保存する前に、このワークスペースをワークスペースドメインで開いてください。",
  "Add the mailbox name for every route before saving.": "保存前にすべてのルートへメールボックス名を設定してください。",
  "Use mailbox names such as support, help, or billing.": "support、help、billing などのメールボックス名を使用してください。",
  "Each workspace mailbox can only appear once.": "各ワークスペースメールボックスは 1 回だけ使用できます。",
  "Add a category name before saving.": "保存する前にカテゴリ名を入力してください。",
  "Give every custom field a label before saving the category.": "カテゴリを保存する前に、すべてのカスタムフィールドにラベルを付けてください。",
  "Custom field labels must be unique within a category.": "カスタムフィールドのラベルはカテゴリ内で一意である必要があります。",
  "A category with this name already exists.": "この名前のカテゴリはすでに存在します。",
  "Manage branding, billing, routing, and workspace operations from one place.": "ブランディング、課金、ルーティング、ワークスペース操作を 1 か所で管理します。",
  "Manage workspace configuration and billing setup for your team.": "チーム向けのワークスペース設定と課金設定を管理します。",
  "Brand setup": "ブランド設定",
  "Primary colour and internal app logo configured for your team workspace": "チームワークスペースのブランドカラーとアプリロゴを設定します。",
  "Ticket categories": "チケットカテゴリ",
  "Shared routing groups used across tickets and the knowledge base": "チケットとナレッジで共通利用されるルーティングカテゴリです。",
  "Inbox routes": "受信ルート",
  "Workspace support mailboxes configured for direct case intake": "ケース受付用に設定されたワークスペースサポートメールボックスです。",
  "Manage the shared taxonomy used for ticket routing and knowledge base organization so teams can reuse the same categories everywhere.": "チケットルーティングとナレッジ整理に使う共通カテゴリ体系を管理し、どこでも同じカテゴリを再利用できるようにします。",
  "No description yet.": "説明はまだありません。",
  "In use": "使用中",
  "Email intake": "メール受付",
  "Workspace support mailboxes": "ワークスペースサポートメールボックス",
  "Choose the mailbox names your workspace will receive on its dedicated Kuii mail subdomain. Customers can email these addresses directly, or you can forward a custom-domain inbox into them.": "専用 Kuii メールサブドメインで受信するメールボックス名を設定します。顧客は直接送信することも、独自ドメインの受信箱を転送することもできます。",
  "Control whether workspace audit and access activity is captured and how long stored log data is retained.": "ワークスペースの監査・アクセス記録を保存するかどうかと、ログ保持期間を設定します。",
  "Kuii records workspace configuration changes, operational updates, and management actions in the workspace audit log stream.": "Kuii はワークスペース設定変更、運用更新、管理操作をワークスペース監査ログに記録します。",
  "No new workspace audit log entries will be written until logging is enabled again.": "ログを再有効化するまで、新しいワークスペース監査ログは記録されません。",
  "Audit logs are retained until you change the policy.": "監査ログはポリシーを変更するまで保持されます。",
  "Toggle audit logs": "監査ログを切り替え",
  "Kuii records login, logout, session, and denied API access attempts in the workspace access log stream.": "Kuii はログイン、ログアウト、セッション、拒否された API アクセス試行をワークスペースアクセスログに記録します。",
  "No new workspace access log entries will be written until logging is enabled again.": "ログを再有効化するまで、新しいワークスペースアクセスログは記録されません。",
  "Access logs are retained until you change the policy.": "アクセスログはポリシーを変更するまで保持されます。",
  "Toggle access logs": "アクセスログを切り替え",

  "Unable to load roles.": "ロールを読み込めません。",
  "Name, email, and role are required.": "名前、メールアドレス、ロールは必須です。",
  "Assign at least one team or ticket category to an agent.": "担当者には少なくとも 1 つのチームまたはチケットカテゴリを割り当ててください。",
  "New workspace users need a temporary password with at least 8 characters.": "新しいワークスペースユーザーには 8 文字以上の仮パスワードが必要です。",
  "Unable to save the workspace user.": "ワークスペースユーザーを保存できません。",
  "Team name is required.": "チーム名は必須です。",
  "Assign at least one ticket category to the team.": "チームには少なくとも 1 つのチケットカテゴリを割り当ててください。",
  "Unable to save the team.": "チームを保存できません。",
  "Unable to delete the team.": "チームを削除できません。",
  "Unable to remove the workspace user.": "ワークスペースユーザーを削除できません。",
  "New passwords need at least 8 characters.": "新しいパスワードは 8 文字以上必要です。",
  "The password confirmation does not match.": "パスワード確認が一致しません。",
  "Unable to update the local password.": "ローカルパスワードを更新できません。",
  "Role name and description are required.": "ロール名と説明は必須です。",
  "Unable to save the role preset.": "ロールプリセットを保存できません。",
  "Unable to delete the role preset.": "ロールプリセットを削除できません。",
  "Active users": "アクティブユーザー",
  "Members who have already signed in to this workspace": "このワークスペースにすでにサインインしたメンバー",
  "Owners and admins with workspace management rights": "ワークスペース管理権限を持つオーナーと管理者",
  "Pending invites": "招待待ち",
  "Accounts that still need their first sign-in": "まだ初回サインインが必要なアカウント",
  "Access policy": "アクセス方針",
  "Read only": "閲覧のみ",
  "This role can update workspace members and roles": "このロールはワークスペースメンバーとロールを更新できます。",
  "This role can review access but not modify it": "このロールはアクセスを確認できますが変更はできません。",
  "Search users by name, email, role, team, or category": "名前、メール、ロール、チーム、カテゴリでユーザーを検索",
  "Search workspace users": "ワークスペースユーザーを検索",
  "Search teams by name, description, category, or member": "名前、説明、カテゴリ、メンバーでチームを検索",
  "Search user teams": "ユーザーチームを検索",
  "No team description yet.": "チーム説明はまだありません。",
  "No teams match that search.": "検索条件に一致するチームはありません。",
  "No teams created yet.": "チームはまだ作成されていません。",
  "Try a different team name, category, description, or member.": "別のチーム名、カテゴリ、説明、またはメンバーで試してください。",
  "Create a team to reuse category coverage across multiple agents.": "複数の担当者でカテゴリ範囲を再利用するにはチームを作成してください。",
  "Search roles by name, description, or permission": "名前、説明、権限でロールを検索",
  "Search role presets": "ロールプリセットを検索",
  "Set password": "パスワードを設定",
  "Set a new local password for this workspace account. Existing sessions for that user will be signed out after the change.": "このワークスペースアカウントの新しいローカルパスワードを設定します。変更後、そのユーザーの既存セッションはサインアウトされます。",
  "Email address": "メールアドレス",
  "New password": "新しいパスワード",
  "Minimum 8 characters": "8 文字以上",
  "Confirm password": "パスワード確認",
  "Repeat the new password": "新しいパスワードを再入力",

  "Avg first response": "平均初回応答",
  "Estimated monthly spend": "推定月額費用",
  "First response": "初回応答",
  "Uses the first recorded update as the current first-response proxy.": "最初に記録された更新を現在の初回応答の代替値として使います。",
  "SLA broken": "SLA 超過",
  "Growth in range": "期間内の成長",
  "Est. monthly spend": "推定月額費用",
  "Monthly spend": "月額費用",
  "Products in use": "利用中の製品",
  "Customers with products": "製品利用中の顧客",
  "Mapped monthly spend": "算出済み月額費用",
  "Monthly spend by product over time": "製品別月額費用の推移",
  "Monthly spend by product": "製品別月額費用",
  "Seats by product over time": "製品別シート数の推移",
  "Seats by product": "製品別シート数",
  "Top customer spenders over time": "顧客別支出上位の推移",
  "Top customer spenders": "顧客別支出上位",
  "Customers by product over time": "製品別顧客数の推移",
  "Customers by product": "製品別顧客数",
  "Ticket reporting": "チケットレポート",
  "Ticket metric": "チケット指標",
  "Product metric": "製品指標",
  "Customer growth over time": "顧客成長の推移",
  "Customer spending over time": "顧客支出の推移",

  "We couldn't find a workspace for this address.": "このアドレスに対応するワークスペースが見つかりませんでした。",
  "Go to landing page": "ランディングページへ",
  "Open app hub": "アプリハブを開く",
};

function normalizeText(value: string) {
  return value.replace(/\s+/g, " ").trim();
}

function preserveOuterWhitespace(original: string, translated: string) {
  const leadingWhitespace = original.match(/^\s*/)?.[0] ?? "";
  const trailingWhitespace = original.match(/\s*$/)?.[0] ?? "";
  return `${leadingWhitespace}${translated}${trailingWhitespace}`;
}

function translateWithPatterns(value: string) {
  const deleteMatch = value.match(/^Delete "(.+)"\? This action cannot be undone\.$/);

  if (deleteMatch) {
    return `「${deleteMatch[1]}」を削除しますか？この操作は元に戻せません。`;
  }

  const createdMatch = value.match(/^Created (.+)$/);

  if (createdMatch) {
    return `作成日 ${createdMatch[1]}`;
  }

  return null;
}

export function translateUiString(value: string, language: AppLanguage) {
  if (language !== "ja") {
    return value;
  }

  const normalized = normalizeText(value);

  if (!normalized) {
    return value;
  }

  const translated = exactTranslations[normalized] ?? translateWithPatterns(normalized);

  if (!translated) {
    return value;
  }

  return preserveOuterWhitespace(value, translated);
}

const ignoredTextSelectors = [
  "script",
  "style",
  "textarea",
  "input",
  "[contenteditable='true']",
  ".codex-editor",
  ".ce-toolbar",
  ".ce-popover",
  ".ce-settings",
  ".ce-inline-toolbar",
  ".ce-block__content",
  ".tc-table",
  ".ce-code",
].join(", ");

const attributeNames = ["placeholder", "aria-label", "title", "alt"] as const;
type TranslatableAttributeName = (typeof attributeNames)[number];

const originalTextByNode = new WeakMap<Text, string>();
const originalAttributesByElement = new WeakMap<Element, Partial<Record<TranslatableAttributeName | "value", string>>>();

function shouldSkipTextNode(node: Text) {
  if (!node.parentElement) {
    return true;
  }

  if (!normalizeText(node.nodeValue ?? "")) {
    return true;
  }

  return Boolean(node.parentElement.closest(ignoredTextSelectors));
}

function translateTextNode(node: Text, language: AppLanguage) {
  if (shouldSkipTextNode(node)) {
    return;
  }

  const currentValue = node.nodeValue ?? "";
  const storedValue = originalTextByNode.get(node);

  if (!storedValue) {
    originalTextByNode.set(node, currentValue);
  } else {
    const translatedStoredValue = translateUiString(storedValue, language);

    if (currentValue !== storedValue && currentValue !== translatedStoredValue) {
      originalTextByNode.set(node, currentValue);
    }
  }

  const sourceValue = originalTextByNode.get(node) ?? currentValue;
  const nextValue = translateUiString(sourceValue, language);

  if (node.nodeValue !== nextValue) {
    node.nodeValue = nextValue;
  }
}

function translateAttribute(element: Element, attributeName: TranslatableAttributeName, language: AppLanguage) {
  const currentValue = element.getAttribute(attributeName);

  if (!currentValue) {
    return;
  }

  const storedAttributes = originalAttributesByElement.get(element) ?? {};
  const storedValue = storedAttributes[attributeName];

  if (!storedValue) {
    storedAttributes[attributeName] = currentValue;
    originalAttributesByElement.set(element, storedAttributes);
  } else {
    const translatedStoredValue = translateUiString(storedValue, language);

    if (currentValue !== storedValue && currentValue !== translatedStoredValue) {
      storedAttributes[attributeName] = currentValue;
      originalAttributesByElement.set(element, storedAttributes);
    }
  }

  const sourceValue = (originalAttributesByElement.get(element) ?? {})[attributeName] ?? currentValue;
  const nextValue = translateUiString(sourceValue, language);

  if (currentValue !== nextValue) {
    element.setAttribute(attributeName, nextValue);
  }
}

function translateInputValue(element: HTMLInputElement, language: AppLanguage) {
  const currentValue = element.value;

  if (!currentValue) {
    return;
  }

  const storedAttributes = originalAttributesByElement.get(element) ?? {};
  const storedValue = storedAttributes.value;

  if (!storedValue) {
    storedAttributes.value = currentValue;
    originalAttributesByElement.set(element, storedAttributes);
  } else {
    const translatedStoredValue = translateUiString(storedValue, language);

    if (currentValue !== storedValue && currentValue !== translatedStoredValue) {
      storedAttributes.value = currentValue;
      originalAttributesByElement.set(element, storedAttributes);
    }
  }

  const sourceValue = (originalAttributesByElement.get(element) ?? {}).value ?? currentValue;
  const nextValue = translateUiString(sourceValue, language);

  if (element.value !== nextValue) {
    element.value = nextValue;
  }
}

function translateRoot(root: HTMLElement, language: AppLanguage) {
  if (typeof document === "undefined") {
    return;
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let currentNode = walker.nextNode();

  while (currentNode) {
    translateTextNode(currentNode as Text, language);
    currentNode = walker.nextNode();
  }

  if (root instanceof Element) {
    attributeNames.forEach(attributeName => {
      translateAttribute(root, attributeName, language);
    });

    if (root instanceof HTMLInputElement && ["button", "submit", "reset"].includes(root.type)) {
      translateInputValue(root, language);
    }
  }

  root.querySelectorAll<HTMLElement>("*").forEach(element => {
    attributeNames.forEach(attributeName => {
      translateAttribute(element, attributeName, language);
    });

    if (element instanceof HTMLInputElement && ["button", "submit", "reset"].includes(element.type)) {
      translateInputValue(element, language);
    }
  });
}

export function useDomTranslations(language: AppLanguage) {
  useEffect(() => {
    if (typeof document === "undefined") {
      return;
    }

    document.documentElement.lang = language;

    const root = document.body;

    if (!root) {
      return;
    }

    let frameId = 0;

    const runTranslation = () => {
      frameId = 0;
      translateRoot(root, language);
    };

    runTranslation();

    const observer = new MutationObserver(() => {
      if (frameId) {
        return;
      }

      frameId = window.requestAnimationFrame(runTranslation);
    });

    observer.observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: [...attributeNames, "value"],
    });

    return () => {
      observer.disconnect();

      if (frameId) {
        window.cancelAnimationFrame(frameId);
      }
    };
  }, [language]);
}